import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPostJson } from './client'

/**
 * Securitee > Email domains (`SecuriteeEmailDomainsController`): domeniile de
 * mail ale firmei din antet si ce spune DNS-ul lor public (MX, SPF, DMARC, DKIM).
 * Momentele sunt UTC.
 */

export type EmailDomainFinding = { key: string; text: string }

export type EmailDomainResult = {
  domain: string
  ns: string[]
  /** DNS-ul pe ns1/ns2.classit.ro: FIX deschide tichet */
  managed: boolean
  mx: string[]
  microsoft365: boolean
  /** fara MX: nu trimite mail, deci trebuie sa refuze tot */
  parked: boolean
  spf: { records: string[]; status: 'missing' | 'multiple' | 'open' | 'neutral' | 'no_all' | 'soft' | 'strict' | 'redirect' }
  dmarc: { record: string | null; policy: 'none' | 'quarantine' | 'reject' | null; status: 'missing' | 'multiple' | 'invalid' | 'monitor' | 'ok' }
  dkim: { status: 'ok' | 'missing' | 'm365_off' | 'n/a'; selectors: { selector: string; cname: string; key: boolean }[] }
  findings: EmailDomainFinding[]
}

export type EmailDomain = { id: number; domain: string; checked_at: string | null; error: string | null; result: EmailDomainResult | null }

export type EmailDomainsPage = { domains: EmailDomain[]; can_edit: boolean; can_ticket: boolean }

export type FixChoice = { all: '-all' | '~all'; policy: 'none' | 'quarantine' | 'reject'; rua: string }

export type FixRecommendation = { spf: string; dmarc: string; dkim: string[]; managed: boolean }

export function emailDomainsQuery() {
  return queryOptions({
    queryKey: ['securitee', 'email-domains'],
    queryFn: () => apiGet<EmailDomainsPage>('/securitee/email-domains'),
  })
}

export function emailDomainFixQuery(id: number, choice: FixChoice) {
  return queryOptions({
    queryKey: ['securitee', 'email-domains', id, 'fix', choice],
    queryFn: () => apiGet<FixRecommendation>(`/securitee/email-domains/${id}/fix?${new URLSearchParams(choice)}`),
  })
}

export function addEmailDomain(domain: string) {
  return apiPostJson<EmailDomainsPage>('/securitee/email-domains', { domain })
}

export function removeEmailDomain(id: number) {
  return apiGet<EmailDomainsPage>(`/securitee/email-domains/${id}`, { method: 'DELETE' })
}

export function checkEmailDomain(id: number) {
  return apiPostJson<EmailDomain>(`/securitee/email-domains/${id}/check`, {})
}

export function fixEmailDomain(id: number, choice: FixChoice) {
  return apiPostJson<{ ticket_id: number }>(`/securitee/email-domains/${id}/fix`, choice)
}
